import { createSafeContext } from '@mantine/utils';
const [ModalProvider, useModalContext] = createSafeContext("Modal component was not found in tree");
export { ModalProvider, useModalContext };